import { Component, OnInit } from '@angular/core';
import {WorkgroupService} from '../workgroup-services/workgroup.service'
import {ActivatedRoute,Router} from '@angular/router';
import {ApprovalComponent} from '../approval/approval.component'
import { MatDialog,MatSnackBar} from '@angular/material';
import {VisitorComponent} from '../visitor/visitor.component'
import {AuthService} from '../../shared/services/auth/auth.service'
import { StaticValueService } from '../../shared/services/static-value.service'
import {AssociateService} from '../../associate/shared/services/associate.service'
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import {Sort} from '@angular/material';
import {Location} from '@angular/common';
@Component({
  selector: 'app-profile-hr',
  templateUrl: './profile-hr.component.html',
  styleUrls: ['./profile-hr.component.css']
})
export class ProfileHrComponent implements OnInit {
  // variables
  public Id:any;
  public isUpdate=false;
  public associates:any;
  public dropdown:any;
  public group:any;  
  public user:any;

  constructor( public service:WorkgroupService,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public auth:AuthService,
    public staticDDListService: StaticValueService,
    public associateService:AssociateService,
    public router:Router,
    public mobileNav: MobileNavService,
    public _location: Location,
  ) { }

  onClickMe() {
    this.mobileNav.showSideNav();
 }

  ngOnInit() {

    this.associates=Object.assign([], this.route.snapshot.data['associates']);
    this.group = Object.assign({}, this.route.snapshot.data['workGroup'])[0];
    this.user=this.auth.user;
    this.dropdown = this.staticDDListService.staticData.staticDD;
      if(this.user.role!=='Admin' && this.user.role!=='Super Admin' && this.user.role!=='OpCo Manager' && this.user.role!=='HR Manager' && this.user.role!=='Marcom Manager')
        this.router.navigate(['/home/working-group/search'])
      // if(this.group.approval!=='pending')
      //    this.router.navigate(['/home/working-group/profile',this.group._id]);      
 
    }

  //approval button popup
  Approval(){
    let dialogRef = this.dialog.open(ApprovalComponent, {
      width: '500px',
      data: {
        group:this.group
      },    
    });
    dialogRef.afterClosed().subscribe(() => {
        this.group.lastValidatedBy={name: this.user.isProxyUser ? this.user.name + ` (${this.user.proxyUser.fullName})` : this.user.name,id: this.user.associateId,time: new Date()}
        this.associateCraeter(this.group.approval,this.group.lastEditedBy[0].id);
        if(this.group.approval=='Approved'){
          var g={
            workingGroupId: this.group._id,
            alias: this.group.groupAlias,
            description: this.group.description,
            status: this.group.groupStatus,
            scope: this.group.scope,
            startDate: this.group.startDate,
            endDate: this.group.endDate,
            approval: 'Approved',
            privacy: this.group.privacySetting,
            groupType : this.group.groupType,
            membersCount : this.group.Members.length
          }
          this.group.Members.filter(member=>{
            if(member.associateId!==this.group.lastEditedBy[0].id && member.associateId){
              this.associateService.getAssociate(member.associateId).subscribe(associate=>{
                if(associate['data'][0]['workGroupsAndCommittees'][0].workingGroupId)  
                  associate['data'][0]['workGroupsAndCommittees'].push(g);
                else 
                    associate['data'][0]['workGroupsAndCommittees']=[g]    
                this.associateService.updateAssociateWorkingGroup(associate[0]).subscribe(res=>{
                },error=>{
                  console.log("associate update error",error)
                });
              });
              this.service.sendMail(member,this.group,0).then(res=>{});  
            }
            else if(member.associateId){
              this.associateService.getAssociate(member.associateId).subscribe(associate=>{
                associate['data'][0]['workGroupsAndCommittees']=associate['data'][0]['workGroupsAndCommittees'].filter(gr=>{
                  if(this.group._id===gr.workingGroupId){
                    gr.approval='Approved';
                    return gr;
                  }
                  else 
                    return gr;
                })
                this.associateService.updateAssociateWorkingGroup(associate['data'][0]).subscribe(res=>{
                  
                },error=>{
                });                        
              });
            }
            else
              this.service.sendMail(member,this.group,0).then(res=>{
                console.log('visitor email send to ',member.email);
              });
            
          });
          this.service.updateWorkGroup(this.group);
          this.router.navigate(['/home/working-group/profile',this.group._id]);      
        }
        else if(this.group.approval=='Disapproved'){
          this.associateService.getAssociate(this.group.lastEditedBy[0].id).subscribe(associate=>{
            associate['data'][0]['workGroupsAndCommittees']=associate['data'][0]['workGroupsAndCommittees'].filter(gr=>{
              if(this.group._id===gr.workingGroupId){
                gr.approval='Disapproved';
                return gr;
              }
              else 
                return gr;
            })
            this.associateService.updateAssociateWorkingGroup(associate['data'][0]).subscribe(res=>{
              console.log("associate updated");
            },error=>{
              console.log("associate update error",error)
            });                        
          });  
          this.service.updateWorkGroup(this.group);
          this.router.navigate(['/home/working-group/search',this.group._id]); 
        }     
    });
  }



  sortData(sort: Sort) {
    let data = Object.assign([],this.group.Members);

    if (!sort.active || sort.direction == '') {
      this.group.Members = data;
      return;
    }
    let isAsc = sort.direction == 'asc';
    var sortedMembers = data.sort((a, b) => {
        switch (sort.active) {
          case 'name': return this.compare(a.fullName.toLowerCase(), b.fullName.toLowerCase(), isAsc);
          case 'organization': return this.compare(a.designation.toLowerCase(), b.designation.toLowerCase(), isAsc);
          case 'role': return this.compare(a.role.toLowerCase(), b.role.toLowerCase(), isAsc);
          case 'startDate': return this.compare(a.startDate, b.startDate, isAsc);
          case 'endDate': return this.compare(a.endDate, b.endDate, isAsc);
          case 'status': return this.compare(a.status.toLowerCase(), b.status.toLowerCase(), isAsc);
          default: return 0;
        }        
    });
    this.group.Members=sortedMembers;
  }
  
  compare(a, b, isAsc) {
    console.log(a,b,(a < b ? -1 : 1) * (isAsc ? 1 : -1))
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }  
  backBtnClick(){
    this._location.back();
  }
  associateCraeter(status,associateId){
    this.associateService.getAssociate(associateId).subscribe(associate=>{
      var member = {associateId:associateId, email:associate['data'][0]['workContactDetails']['workEmail']}
      if(status==='Approved'){
        this.service.sendMail(member,this.group,2).then(res=>{});  
      } else if (status === 'Disapproved'){
        this.service.sendMail(member,this.group,1).then(res=>{});  
      }

    });


  }
}
